import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
Highcharts.setOptions({
    plotOptions: {
        series: {
            animation: false,
        },
    },
    lang: {
        thousandsSep: ",",
    },
    credits: false,
});
var ChartType6 = function (props) {
    var values = props.values, titles = props.titles, colors = props.colors, prefix = props.prefix, postfix = props.postfix, height = props.height;
    var symbol = prefix || "";
    var sign = postfix || "";
    var options = {
        chart: {
            type: "bar",
            backgroundColor: "transparent",
            height: height ? height : 200,
            style: { fontFamily: "Poppins, sans-serif" },
            reflow: true,
            className: "chartType_3",
            options3d: {
                enabled: false,
                alpha: 45,
                beta: 0,
            },
        },
        title: {
            useHTML: true,
            text: "",
            style: {
                fontWeight: "normal",
                color: "#000000",
                fontSize: "16px",
            },
        },
        subtitle: {
            useHTML: true,
            text: "",
            style: {
                fontWeight: "normal",
                color: "#000000",
                fontSize: "16px",
            },
        },
        credits: { enabled: false },
        yAxis: {
            title: {
                text: "",
                style: {
                    fontWeight: "normal",
                    fontSize: "12px",
                },
            },
            gridLineColor: "#ffffff",
            gridLineWidth: 0,
            labels: {
                enabled: false,
                style: {
                    fontWeight: "normal",
                    fontSize: "16px",
                    color: "#000000",
                },
                formatter: function () {
                    return (symbol +
                        "" +
                        Highcharts.numberFormat(this.y / 1, 1) +
                        "" +
                        sign).replace(/ /g, "");
                },
            },
        },
        tooltip: {
            enabled: false,
            format: "{point.name}: " + "$" + "{point.y:,.1f}",
            pointFormat: "" + "$" + "{point.y:,.1f}<br/>",
            shared: true,
            useHTML: true,
            style: {
                fontWeight: "normal",
                color: "#000000",
                fontSize: "16px",
            },
        },
        xAxis: {
            title: {
                text: "",
                style: {
                    fontWeight: "normal",
                    fontSize: "12px",
                },
            },
            categories: ["Current", "With Company"],
            crosshair: true,
            labels: {
                enabled: false,
                style: {
                    fontWeight: "400",
                    fontSize: "16px",
                    color: "#000000",
                },
            },
        },
        plotOptions: {
            series: {
                pointWidth: 50,
                borderRadius: 3,
                groupPadding: 1,
                colors: ["#64c1c6", "#df6c5a"],
                borderWidth: 0,
                dataLabels: {
                    enabled: true,
                    formatter: function () {
                        return symbol + "" + Highcharts.numberFormat(this.y, 0) + "" + sign;
                    },
                    style: {
                        fontSize: "18px",
                        fontWeight: 700,
                    },
                },
            },
        },
        series: [
            {
                name: "John",
                data: [5],
            },
            {
                name: "Jane",
                data: [4],
            },
        ],
        legend: {
            enabled: true,
            itemStyle: {
                fontSize: "16px",
                fontWeight: 400,
                color: "#000000",
            },
        },
    };
    if (values && titles && values.length > 0 && titles.length == values.length) {
        var data_1 = [];
        var categories_1 = [];
        values.map(function (value, i) {
            data_1.push({
                name: titles[i],
                data: [value],
                color: (colors && colors[i]) || "",
            });
            categories_1.push(titles[i]);
        });
        options.xAxis.categories = categories_1;
        options.series = data_1;
    }
    var HandleObject = function (object, new_options) {
        Object.keys(object).map(function (e) {
            if (Object.keys(object[e]).length > 0 && typeof object[e] === "object") {
                HandleObject(object[e], new_options[e]);
            }
            else {
                new_options[e] = object[e];
            }
        });
    };
    var custom_options = props.custom_options;
    if (custom_options) {
        if (Object.keys(custom_options).length > 0) {
            Object.keys(custom_options).map(function (e) {
                if (Object.keys(custom_options[e]).length > 0 &&
                    typeof custom_options[e] === "object") {
                    HandleObject(custom_options[e], options[e]);
                }
                else {
                    options[e] = custom_options[e];
                }
            });
        }
    }
    if (props.debug_mood) {
        console.log("high chart debug mood", options);
    }
    return (React.createElement("div", null,
        React.createElement(HighchartsReact, { highcharts: Highcharts, options: options })));
};
export default ChartType6;
